// Note: Deeplinking to a particular section requires that the keys here remain unchanged
// Gameclient.com/profile?section=achievements -> open profile with section.toUpperCase()

const ALL_MENU_ITEMS = {
	OVERVIEW: {id: 'overview', title: 'profile.overview.menu-title'},
	REFER_A_FRIEND: {id: 'refer-a-friend', title: 'profile.refer-a-friend'},
	INBOX: {id: 'inbox', title: 'profile.inbox'},
	PRIVATE_GAMES: {id: 'private-games', title: 'profile.private-games.title'},
	BETA_TESTING: {id: 'beta-testing', title: 'profile.beta-testing.title'},
	ACHIEVEMENTS: {id: 'achievements', title: 'profile.achievements'},
	CHALLENGES: {id: 'challenges', title: 'profile.challenges'},
	LEADERBOARDS: {id: 'leaderboards', title: 'profile.leaderboards'},
	ACCOUNT: {id: 'account', title: 'account.title'},
	AVATARS: {id: 'avatars', title: 'profile.avatars'},
	ITEMS: {id: 'items', title: 'profile.items'},
	STORE: {id: 'store', title: 'profile.store'},
	GAMEPLAY_HISTORY: {id: 'gameplay-history', title: 'profile.gameplay-history'},
	TRANSACTION_HISTORY: {id: 'transaction-history', title: 'profile.transaction-history'},
	RESPONSIBLE_GAMING: { id: 'responsible-gameplay', title: 'profile.responsible-gameplay' },
	SETTINGS: {id: 'settings', title: 'settings.title'},
	DEBUG: {id: 'debug', title: 'profile.debug'},
	LOGOUT: {id: 'logout', title: 'profile.logout'},
}

export const SECTION = (() => {
	return ALL_MENU_ITEMS
})()
